import { render, staticRenderFns } from "./VersionCourte.vue?vue&type=template&id=2b710e0d&scoped=true&"
import script from "./VersionCourte.vue?vue&type=script&lang=js&"
export * from "./VersionCourte.vue?vue&type=script&lang=js&"
import style0 from "./VersionCourte.vue?vue&type=style&index=0&id=2b710e0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b710e0d",
  null
  
)

component.options.__file = "VersionCourte.vue"
export default component.exports